module.exports = __webpack_public_path__ + "img/practice.727de7fb.svg";